import axios from '../../plugins/axios'

export const getCancelledDeliveriesConfig = () => {
  return axios.get('/settings/cancelled-deliveries')
}

export const updateCancelledDeliveriesConfig = (_, { data }) => {
  return axios.put('/settings/cancelled-deliveries', data)
}
